var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.518 64.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.943,
    y1: 0.375,
    x2: 0.186,
    y2: 0.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42dee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0da1ba"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_2",
    d: "M48.028,17.436a2.556,2.556,0,0,0-2.2-1.758l-13.9-1.262L26.433,1.555a2.56,2.56,0,0,0-4.709,0L16.23,14.416l-13.9,1.262A2.563,2.563,0,0,0,.873,20.156L11.38,29.37l-3.1,13.646a2.559,2.559,0,0,0,3.808,2.767l11.986-7.167,11.984,7.167a2.561,2.561,0,0,0,3.811-2.767l-3.1-13.646,10.508-9.214a2.563,2.563,0,0,0,.747-2.721ZM24.308,38.478",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, 0, 26.226)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star_2.08f451d394e3f7f4faf5c6a87f0d45a4.svg";
export { ForwardRef as ReactComponent };